jQuery(document).ready(function ($) {
    $('.best_seller_row .product-grid').addClass('owl-carousel');
    $('.best_seller_row .product-grid').owlCarousel({
      loop: false,
      nav: true,
      margin: 25,
      dots: false,
      responsive: {
        0: {
          items: 1,
          margin: 0
        },
        421: {
          items: 1,
          margin: 10
        },
        600: {
          items: 2,
          margin: 10
        },
        800: {
          items: 3,
          margin: 10
        },
        1000: {
          items: 4,
          margin: 15
        },
        1201: {
          items: 4
        }
      }
    });
  
  $('.custom_testimonials_row .testimonials-items').addClass('owl-carousel');
  $('.custom_testimonials_row .testimonials-items').owlCarousel({
      loop: false,
      nav: false,
      margin: 25,
      dots: false,
      responsive: {
        0: {
          items: 1,
          margin: 0
        },
        421: {
          items: 2,
          margin: 10
        },
        600: {
          items: 2,
          margin: 10
        },
        800: {
          items: 3,
          margin: 10
        },
        1000: {
          items: 4,
          margin: 15
        },
        1201: {
          items: 5
        }
      }
  });
  $('.multicolumns_row .multicolumns_list').addClass('owl-carousel');
  $('.multicolumns_row .multicolumns_list').owlCarousel({
      loop: false,
      nav: true,
      margin: 15,
      dots: false,
      responsive: {
        0: {
          items: 1,
          margin: 0
        },
        581: {
          items: 2,
          margin: 10
        },
        800: {
          items: 2,
          margin: 10
        },
        1000: {
          items: 4
        }
      }
    });
});

$(document).ready(function() {
    $('.accordion-header, .custom_faqs_row .faqs_title').click(function() {
        $(this).next('.accordion-content, .faqs_itmes .faqs_content').slideToggle();
        $('.accordion-content, .faqs_itmes .faqs_content').not($(this).next()).slideUp();
        $(this).toggleClass('active');
        $('.accordion-header, .custom_faqs_row .faqs_title').not($(this)).removeClass('active');
    });
});


jQuery(document).ready(function($){
  // Event delegation for size chart button
  jQuery(document).on('click', '.size_chart_label .size_chart_btn a', function() {
      jQuery('.size_chart_modal').addClass('is-visible');
  });

  // Event delegation for close button
  jQuery(document).on('click', '.close', function(){
      jQuery('.size_chart_modal').removeClass('is-visible');
  });
});


$(document).ready(function() {
  $(document).on('click', '.size_chart_label .fp-recommendation', function() {
      $('#truesize_popup1').fadeIn();
      $('#truesize_popup_overlay').fadeIn();
  });
  $(document).on('click', '#info_btn', function() {
      $('#truesize_popup1').hide();
      $('#truesize_popup2').fadeIn();
  });
  $(document).on('click', '.close_btn', function() {
      $(this).parent('.true_size_popup').fadeOut();
      $('#truesize_popup_overlay').fadeOut();
  });
  $(document).on('click', '#back_btn', function() {
      $('#truesize_popup2').fadeOut();
      $('#truesize_popup1').fadeIn();
  });
});

